module.exports = __webpack_public_path__ + "static/img/2.b82124c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/2.png
// module id = RHMa
// module chunks = 0